<template>
  <div>
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal-reporte-turnos-tep"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">
              <i class="fas fa-filter mr-2"></i>
              Reporte Turnos TEP
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Cerrar"
              ref="cerrarModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-muted small">
              Selecciona el rango de fechas para generar el reporte.
            </p>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="small mb-1">Fecha inicial</label>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="form.fecha_inicial"
                  :class="
                    $v.form.fecha_inicial.$invalid ? 'is-invalid' : 'is-valid'
                  "
                />
                <div class="invalid-feedback">
                  La fecha inicial es requerida.
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="small mb-1">Fecha final</label>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="form.fecha_final"
                  :class="
                    $v.form.fecha_final.$invalid ? 'is-invalid' : 'is-valid'
                  "
                />
                <div class="invalid-feedback">La fecha final es requerida.</div>
              </div>
            </div>
            <div
              v-if="rangoInvalido"
              class="alert alert-warning py-2 mb-0 small"
            >
              <i class="fas fa-exclamation-triangle mr-1"></i>
              La fecha final no puede ser menor a la fecha inicial.
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="fas fa-times mr-1"></i>
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-success"
              :disabled="$v.form.$invalid || rangoInvalido"
              @click="generar()"
            >
              <i class="fas fa-download mr-1"></i>
              Generar y descargar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import Loading from "../../../../components/Loading";

export default {
  name: "ReporteTurnosTep",
  components: {
    Loading,
  },
  data() {
    return {
      cargando: false,
      form: {
        fecha_inicial: "",
        fecha_final: "",
      },
    };
  },
  validations: {
    form: {
      fecha_inicial: {
        required,
      },
      fecha_final: {
        required,
      },
    },
  },
  computed: {
    rangoInvalido() {
      if (!this.form.fecha_inicial || !this.form.fecha_final) {
        return false;
      }
      return this.form.fecha_final < this.form.fecha_inicial;
    },
  },
  methods: {
    limpiarModal() {
      this.form = {
        fecha_inicial: "",
        fecha_final: "",
      };
    },
    generar() {
      if (this.$v.form.$invalid || this.rangoInvalido) {
        return;
      }

      this.cargando = true;
      axios({
        method: "GET",
        url: "/api/funcionariosFrontera/reportes/turnosTep/export",
        params: {
          fecha_inicial: this.form.fecha_inicial,
          fecha_final: this.form.fecha_final,
        },
      })
        .then((response) => {
          this.cargando = false;
          if (this.$refs.cerrarModal) {
            this.$refs.cerrarModal.click();
          }
          if (response.data && response.data.url) {
            location.href = response.data.url;
          }
          this.$swal({
            icon: "success",
            title: "Reporte generado correctamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error, vuelva a intentarlo..." + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
  },
};
</script>
